module.exports = __webpack_public_path__ + "static/img_0-dcf177ca2bc0c1d204df66302aee8ff0.png";